<template>
  <div>
    <myheader
      :backFlag="true"
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="文件签署"
    ></myheader>
    <div class="all_main">
      <div
        class="all_list_content_nopadding"
        id="pdfcontainer"
        style="top: 4.2rem; bottom: 0; background-color: white"
      ></div>
    </div>
    <van-popup v-model:show="pop_show" round :style="{ width: '80%' }">
      <div class="sms_pop_parent" @click.stop>
        <div>
          <div class="all_height_line14 margin_top_5 margin_bottom_5">
            <span
              class="all_text_center all_line_height14 text14 textcolor333 font_weight_bold"
              style="display: inline-block; width: 26%; margin-left: 38%"
              >验证码签约</span
            >
          </div>
          <div class="horizontal_line margin_top_5"></div>
          <div class="pop_content margin_top_5">
            <div
              class="all_input all_height30"
              :class="{ isfocus: verifyFocus }"
            >
              <div class="display_inline_block" style="width: 55%">
                <van-field
                  type="number"
                  placeholder="请输入计算结果"
                  v-model="verifyCode"
                  @focus="getFocus(1)"
                  @blur="onblur(1)"
                  maxlength="6"
                  clearable
                >
                </van-field>
              </div>
              <span
                @click="getPictureImg()"
                class="display_inline_block"
                title="看不清,换一个"
                style="width: 40%"
              >
                <img
                  :src="verifyImg"
                  style="height: 2rem; width: 5rem"
                  fill
                  title="看不清,换一个"
              /></span>
            </div>
            <div class="all_input all_height30" :class="{ isfocus: codeFocus }">
              <div class="display_inline_block" style="width: 50%">
                <van-field
                  v-model="smsCode"
                  type="number"
                  maxlength="6"
                  placeholder="请输入验证码"
                  clearable
                  @focus="getFocus(2)"
                  @blur="onblur(2)"
                />
              </div>
              <span
                @click="getCode()"
                class="display_inline_block text14 all_text_right all_line_height20"
                style="width: 45%"
                :class="{
                  textcolormain: timer === 60,
                  textcolor999: timer != 60,
                }"
              >
                {{ timer === 60 ? "获取验证码" : timer + "s后再次获取" }}</span
              >
            </div>
          </div>
          <div class="margin_top_10 margin_bottom_5 all_height20">
            <button
              id="switchFAuth"
              ref="switchFAuth"
              class="text14 all_line_height20 textcolorwhite backgroundC_main"
              style="
                display: inline-block;
                width: 35%;
                margin-left: 5%;
                border-radius: 5px;
                visibility: hidden;
              "
              @click="switchFaceAuth()"
            >
              切换人脸认证
            </button>
            <button
              class="text14 all_line_height20 textcolormain backgroundC_#f2f2f2"
              style="
                display: inline-block;
                width: 25%;
                margin-left: 3%;
                border-radius: 5px;
              "
              @click="dimiss()"
            >
              取消
            </button>
            <button
              class="text14 all_line_height20 textcolorwhite backgroundC_main"
              style="
                display: inline-block;
                width: 25%;
                margin-left: 2%;
                border-radius: 5px;
              "
              @click="popSumbit()"
            >
              确定
            </button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Field,
  Dialog
} from 'vant';
import {
  realLiveAuth,
  initIosAuth
} from '../../utils/nativeRealLiveAuth.js';
import {
  closeCurrentPage,
  getDeviceTypeName,
} from '../../utils/nativeOtherOperate.js'
import {
  getSealHashSign
} from '../../utils/nativeCertSign.js';
import {
  setEssToken
} from "../../utils/cookies.js";
export default {
  name: 'SingleContractSignOrSeal',
  components: {
    [Field.name]: Field,
  },
  data() {
    return {
      //
      resId: '',
      //
      docId: '',
      // 企业id
      corpId: '',
      //
      staffId: '',
      //
      certType: '',
      //
      signetType: '',
      //
      segId: '',
      //
      appCode: '',
      //
      token: '',
      //
      iframeName: 'Iframe0',
      //
      scrollTop: 0,
      //
      acted: false,
      //
      keyTypeName: '签名',
      //签名盖章数据
      submitData: {
        models: []
      },
      //iframe高度
      iframeHeight: '90vh',
      //活体认证token
      verifyToken: '',
      //
      pop_show: false,
      //验证码倒计时
      timer: 60,
      //
      timerInterval: null,
      //图片验证结果
      verifyCode: '',
      //验证Id
      verifyId: '',
      //验证图片
      verifyImg: '',
      //验证码
      smsCode: '',
      //
      codeFocus: false,
      verifyFocus: false,
      //
      clickId: '',
      //
      retryIndex: 0,
      //
      retryCount: 0,
    }
  },
  methods: {
    //
    back() {
      closeCurrentPage(0)
    },
    //
    popShow(flag = false) {
      this.smsCode = ''
      this.getPictureImg()
      this.pop_show = true
      if (flag) {
        setTimeout(() => {
          document.getElementById('switchFAuth').style.visibility = 'visible'
          if (getDeviceTypeName() === 'iOS') {
            document.getElementById('switchFAuth').style.opacity = '0'
            document.getElementById('switchFAuth').style.pointerEvents = 'none'
          }
        }, 200)
      }
    },
    //
    getPictureImg() {
      this.verifyCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealg('/api/sms/verifyImg', {}, this.submitData.models[0].params.appCode).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.verifyId = res.data.verifyId
          this.verifyImg = res.data.srcImg
        } else {
          this.verifyImg = ''
          this.$Toast("未获取到验证图片！");
        }
      }).catch((err) => {
        this.verifyImg = ''
        this.$store.dispatch(this.$LoadShow, false)
        console.log('verifyImg', err)
      });
    },
    //
    switchFaceAuth() {
      this.faceCompareAuth()
    },
    //
    getFocus(id) {
      if (id == 1) {
        this.verifyFocus = true;
      } else if (id == 2) {
        this.codeFocus = true;
      }
    },
    //
    onblur(id) {
      if (id == 1) {
        this.verifyFocus = false;
      } else if (id == 2) {
        this.codeFocus = false;
      }
    },
    //
    dimiss() {
      this.timer = 60;
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }
      this.verifyCode = ''
      this.smsCode = ''
      this.pop_show = false
    },
    //
    getCode() {
      let that = this
      if (this.timer != 60) {
        return
      }
      if (!this.verifyId || !this.verifyCode) {
        this.$Toast("请输入图片验证码计算结果！");
        return
      }
      this.smsCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp("/api/sms/sendCode", JSON.stringify({
        staffId: this.submitData.models[0].params.staffId,
        resId: this.submitData.models[0].params.resId,
        corpId: this.submitData.models[0].params.corpId,
        verify: {
          id: this.verifyId,
          code: this.verifyCode
        }
      }), this.submitData.models[0].params.appCode).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          this.$Toast("验证码已发送，请注意查收！");
          this.timer--;
          this.timerInterval = setInterval(() => {
            this.timer--;
            if (this.timer == 0) {
              this.timer = 60;
              clearInterval(that.timerInterval)
            }
          }, 1000);
        } else {
          this.$Toast(res.message || res.messageDetail || "获取验证码失败！");
          this.getPictureImg()
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        this.getPictureImg()
        console.log('/api/sms/sendCode', err)
      });
    },
    //
    popSumbit() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp("/api/sms/verifyCode", JSON.stringify({
        staffId: this.submitData.models[0].params.staffId,
        resId: this.submitData.models[0].params.resId,
        smsCode: this.smsCode,
        corpId: this.submitData.models[0].params.corpId
      }), this.submitData.models[0].params.appCode).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.timer = 60;
          if (this.timerInterval) {
            clearInterval(this.timerInterval)
          }
          this.verifyToken = res.data
          this.pop_show = false
          this.getSignFileHash(0)
        } else {
          this.$Toast(res.message || res.messageDetail || "获取验证码失败！");
          this.getPictureImg()
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        this.getPictureImg()
        console.log('/api/sms/verifyCode', err)
      });
    },
    //获取esstoken
    getAppToken() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/seal/api/genAppToken', {
        appCode: this.appCode
      }).then((res) => {
        if (res.success && res.data) {
          this.token = res.data
          this.setIframeSrc()
        } else {
          this.showMessageInfoAlert((res.message || res.messageDetail) + ',返回上一级重试！', 0)
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.showMessageInfoAlert('获取token失败，请联系管理员！', 0)
      });
    },
    //
    setIframeSrc() {
      let src = '' //根据参数自己拼
      let srcParams =
        `appCode=${this.appCode}&resId=${this.resId}&docId=${this.docId}&corpId=${this.corpId}&staffId=${this.staffId}&certType=${this.certType}&signetType=${this.signetType}&verifyMode=SMS&isMobile=true&allowSealDate=&allowSignDate=&token=${this.token}`
      if (process.env.NODE_ENV === 'development') {
        src = '/seal/index?host=http://10.208.156.94:8060&' + srcParams
      } else {
        src = '/seal/index?' + srcParams
      }
      this.iframeHeight = document.getElementById('pdfcontainer').clientHeight
      let theFrag = document.createDocumentFragment()
      let theIframe = document.createElement('iframe');
      theIframe.setAttribute('id', this.iframeName);
      theIframe.setAttribute('class', 'iframe-style');
      theIframe.setAttribute('style', 'display:block;height:' + this
        .iframeHeight + 'px');
      theIframe.setAttribute('src', src);
      theFrag.appendChild(theIframe);
      document.getElementById('pdfcontainer').appendChild(theFrag)
    },
    //切换为查看状态 
    //flag true view,false sign
    switchSignToView(flag) {
      if (flag) {
        this.refreshIframe(1)
      } else {
        this.clickId = ''
        document.getElementById('pdfcontainer').removeChild(document.getElementById(this.iframeName));
        this.setIframeSrc()
      }
    },
    //刷新合同
    //flag 1 完成签署刷新，0 继续签署刷新
    refreshIframe(flag) {
      this.$store.commit('changeContractStatus', true)
      //pdf页面本地刷新
      let tempIframe = document.getElementById(this.iframeName);
      let model = this.submitData.models.find(item => item.params.docId === this.docId)
      //console.log('model-=', this.submitData.models, this.currentDocumentObject[key], model)
      if (model) {
        //console.log('---model----', model.params.fileId)
        tempIframe.contentWindow.refresh(model.params.fileId, this.scrollTop, flag)
      } else {
        tempIframe.contentWindow.refresh('', this.scrollTop, flag)
      }
      this.submitData = {
        models: [],
      }
    },
    //进入页面活体认证
    faceCompareAuth() {
      this.pop_show = false
      realLiveAuth({
        type: '2',
        staffId: this.$store.state.loginInfo.staffId
      })
    },
    //人脸对比成功
    faceCompareAuthSucced(requestId) {
      //获取verifyToken
      this.getVerifyToken(requestId)
    },
    //人脸对比失败
    faceCompareAuthFailed(message) {
      if (this.submitData.models[0].params.verifyMode === 'FACE_SMS') {
        this.$Toast('调用人脸对比失败，请使用验证码签约！')
        this.popShow(true)
      } else {
        this.$Toast(message || '调用人脸对比失败，请重试！')
      }
    },
    //获取verifyToken
    getVerifyToken(requestId) {
      this.$sealp("/api/face/verifyState", {
        requestId: requestId,
        staffId: this.submitData.models[0].params.staffId,
        resId: this.submitData.models[0].params.resId,
        corpId: this.submitData.models[0].params.corpId,
      }, this.submitData.models[0].params.appCode).then((res) => {
        if (res.success && res.data) {
          this.verifyToken = res.data
          //获取verifyToken成功后开始签章流程
          this.getSignFileHash(0)
          //获取verifyToken成功后轮询页面并赋值然后加载
          //this.setIframeVerifyToken(res.data.verifyToken)
        } else {
          this.$Toast(res.message || res.messageDetail || '人脸对比失败，请重试！')
        }
      });
    },
    //
    verifyTokenSumbit() {
      if (Array.isArray(this.submitData.models) && this.submitData.models.length > 0) {
        if (this.certType === '0') {
          //循环提交签名
          this.signetSumbit(0)
        } else {
          this.clickId = this.Tool.generateUUID()
          if (this.Tool.isNoEmty(this.submitData.models[0].params.verifyToken)) {
            this.verifyToken = this.submitData.models[0].params.verifyToken
            //测试跳过人脸对比
            this.getSignFileHash(0)
            //开始盖章流程
            //this.sealerSumbitFlow()
          } else {
            if (this.submitData.models[0].params.verifyMode === 'SMS') {
              this.popShow()
            } else {
              this.faceCompareAuth()
            }
          }
        }
      } else {
        this.switchSignToView(1)
      }
    },
    //提交
    sumbit() {
      if (this.certType === '0') {
        //循环提交签名
        this.signetSumbit(0)
      } else {
        //测试跳过人脸对比
        this.getSignFileHash(0)
        //开始盖章流程
        //this.sealerSumbitFlow()
      }
    },
    //签名提交
    signetSumbit(index) {
      //console.log(this.submitData)
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealps('/api/doc/sign/event', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        segId: this.submitData.models[index].params.segId,
        lockId: this.submitData.models[index].params.lockId,
        fileId: this.submitData.models[index].params.fileId,
        corpId: this.submitData.models[index].params.corpId,
        staffId: this.submitData.models[index].params.staffId,
        allowSignDate: this.submitData.models[index].params.allowSignDate,
        pages: this.submitData.models[index].pages
      }), {
        appCode: this.submitData.models[index].params.appCode,
        //verifyToken: this.verifyToken,
        authenToken: this.token
      }).then((res) => {
        if (res.success) {
          this.acted = true
          this.submitData.models[index].params.lockId = res.data.lockId
          this.submitData.models[index].params.fileId = res.data.fileId
          if (index === this.submitData.models.length - 1) {
            this.$store.dispatch(this.$LoadShow, false)
            //this.$Toast('签名成功!')
            this.switchSignToView(1)
            //this.refreshIframe(0)
          } else {
            index++
            if (this.submitData.models[index - 1].params.docId === this.submitData.models[
              index].params.docId) {
              this.submitData.models[index].params.lockId = res.data.lockId
              this.submitData.models[index].params.fileId = res.data.fileId
            }
            this.signetSumbit(index)
          }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '签名失败，请重试!')
          this.refreshIframe(0)
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/event', error)
        this.$Toast('签名失败，请重试!')
        this.refreshIframe(0)
      })
    },
    //盖章提交流程开始
    sealerSumbitFlow() {
      //人脸对比认证
      realLiveAuth({
        type: '2',
        staffId: this.$store.state.loginInfo.staffId,
        corpId: this.corpId
      })
      // this.startFaceCompareAuth()
      //循环
      //根据章获取文件hash使用证书签署
      //签署文件
    },
    //获取印章文件hash值 
    //index 循环请求
    getSignFileHash(index) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealps('/api/doc/sign/pkcs', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        segId: this.submitData.models[index].params.segId,
        lockId: this.submitData.models[index].params.lockId,
        fileId: this.submitData.models[index].params.fileId,
        certId: this.submitData.models[index].certId,
        signetImgId: this.submitData.models[index].signetId,
        corpId: this.submitData.models[index].params.corpId,
        staffId: this.submitData.models[index].params.staffId,
        allowSealDate: this.submitData.models[index].params.allowSealDate,
        page: {
          x: this.submitData.models[index].x,
          y: this.submitData.models[index].y,
          index: this.submitData.models[index].index,
          //zoom: this.submitData.models[index].zoom,
          timeFlag: this.submitData.models[index].timeFlag,
          reason: this.submitData.models[index].reason
        },
        isMobile: true,
        enKey: ''
      }), {
        appCode: this.submitData.models[index].params.appCode,
        verifyToken: this.verifyToken,
        authenToken: this.token
      }).then((res) => {
        if (res.success && res.data) {
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          // for (let i = 0; i <= index; i++) {
          // 	if (this.submitData.models[i].params.docId === this.submitData.models[index].params
          // 		.docId) {
          // 		this.submitData.models[i].params.lockId = res.data.lockId
          // 		this.submitData.models[i].params.fileId = res.data.fileId
          // 	}
          // }
          //缓存返回数据
          //this.submitData.models[index].data = res.data
          this.signFlowSealHashSign(index, res.data, this.$store.state.loginInfo.userName)
          // let result = getSealHashSign(res.data.signingAttr.certSn, res.data.signingPkcs,
          // 	this.$store.state.loginInfo.userName)
          // // if (index == 2) {
          // // 	result = result.replaceAll('1', '2').replaceAll('A', '2')
          // // }
          // if (result) {
          // 	this.signFlowItemFinish(index, result, res.data)
          // } else {
          // 	this.$store.dispatch(this.$LoadShow, false)
          // 	this.$Toast('证书签名失败，请检查用户证书！')
          // }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '盖章获取数据失败，请联系管理员!')
          this.switchSignToView(0)
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/pkcs', error)
        this.$Toast('盖章获取数据失败，请重试!')
        this.switchSignToView(0)
      })
    },
    //
    signFlowSealHashSign(index, hashdata, userName) {
      getSealHashSign(hashdata.signingAttr.certSn, hashdata.signingPkcs, userName).then(res => {
        if (res) {
          // if (index == 2) {
          // 	res = res.replaceAll('1', '2').replaceAll('A', '2')
          // }
          this.signFlowItemFinish(index, res, hashdata)
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast('证书签名失败，请检查用户证书！')
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('证书签名失败，请检查用户证书！')
      })
    },
    //提交签署一个印章数据
    signFlowItemFinish(index, signdata, data) {
      let isFinish = false
      if (index < this.submitData.models.length - 1) {
        if (this.submitData.models[index].params.docId !== this.submitData.models[index + 1].params.docId) {
          isFinish = true
        }
      }
      if (index === this.submitData.models.length - 1) {
        isFinish = true
      }
      this.$sealps('/api/doc/sign/save', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        segId: this.submitData.models[index].params.segId,
        // lockId: this.submitData.models[index].params.lockId,
        // fileId: this.submitData.models[index].params.fileId,
        lockId: data.lockId,
        fileId: data.fileId,
        corpId: this.submitData.models[index].params.corpId,
        staffId: this.submitData.models[index].params.staffId,
        signedData: signdata,
        signingAttr: data.signingAttr,
        qrRequestId: data.qrRequestId,
        isFinished: isFinish,
        clkId: this.clickId,
        enKey: ''
      }), {
        appCode: this.submitData.models[index].params.appCode,
        verifyToken: this.verifyToken,
        authenToken: this.token
      }).then((res) => {
        if (res.success && res.data) {
          this.retryIndex = 0
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          this.acted = true
          for (let i = 0; i <= index; i++) {
            if (this.submitData.models[i].params.docId === this.submitData.models[index].params
              .docId) {
              this.submitData.models[i].params.lockId = res.data.lockId
              this.submitData.models[i].params.fileId = res.data.fileId
            }
          }
          if (index === this.submitData.models.length - 1) {
            this.$store.dispatch(this.$LoadShow, false)
            //this.$Toast('盖章成功!')
            if (process.env.NODE_ENV === 'development') {
              this.switchSignToView(1)
              //变成预览模式
              //this.refreshIframe(0)
            } else {
              this.switchSignToView(1)
            }
          } else {
            index++
            //不同文档连续盖章时，fileId和lockId不切换,相同文档连续盖章时，fileId和lockId需要替换成新的
            if (this.submitData.models[index - 1].params.docId === this.submitData.models[
              index].params.docId) {
              this.submitData.models[index].params.lockId = res.data.lockId
              this.submitData.models[index].params.fileId = res.data.fileId
            }
            this.getSignFileHash(index)
          }
        } else {
          //当ios端签名数据验证失败时，重新获取签名数据 重新 盖章 
          if (res.code == 'VE001') {
            if (this.retryIndex >= 5) {
              this.retryIndex = 0
              this.$store.dispatch(this.$LoadShow, false)
              this.showMessageInfoAlert('盖章失败，请继续拖动印章到文件还未盖章处，点击【签署文件】完成盖章!', 0, '关闭')
            } else {
              this.retryIndex++
              this.submitData.models[index].params.lockId = data.lockId
              //this.submitData.models[index].params.fileId = data.fileId
              this.getSignFileHash(index)
            }
            this.retryCount++
          } else {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast(res.message || res.messageDetail || '盖章失败，请重试!')
            this.switchSignToView(0)
          }
          console.log('retryIndex-=', this.retryIndex, this.retryCount)
          // this.$store.dispatch(this.$LoadShow, false)
          // this.$Toast(res.message || res.messageDetail || '盖章失败，请重试!')
          // this.switchSignToView(0)
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/save', error)
        this.$Toast('盖章失败，请重试!')
        this.switchSignToView(0)
      })
    },



    //核查签名或盖章数据
    checkSignDatas() {
      let that = this
      //console.log('currentDocumentObject-=', this.currentDocumentObject)
      this.submitData.models = []
      //console.log(keys)
      let canSubmit = true
      //console.log(key)
      let tempIframe = document.getElementById(this.iframeName);
      //console.log(tempIframe)
      if (tempIframe) {
        //console.log('获取到的参数--=',tempIframe.contentWindow.getQueryParams())	
        this.scrollTop = tempIframe.contentWindow.getPageScrollTop()
        let theIframeSealData = that.certType === '0' ? tempIframe
          .contentWindow.submitTheDataOther() : tempIframe
            .contentWindow.submitTheData();
        if (!that.acted &&
          (!theIframeSealData || !Array.isArray(theIframeSealData
            .pages) || theIframeSealData.pages.length === 0)) {
          Dialog.alert({
            title: '提示',
            message: '文档《' + that
              .currentDocumentObject[key].documentName +
              '》还未' +
              that.keyTypeName + '，或请将' + that.keyTypeName +
              '图片拖动到文件待' + that.keyTypeName + '处！',
            confirmButtonText: '关闭',
            confirmButtonColor: '#0277FC'
          }).then(() => { });
          canSubmit = false
        }
        if (theIframeSealData && Array.isArray(theIframeSealData
          .pages) && theIframeSealData.pages.length > 0) {
          let filterPageY = theIframeSealData.pages.filter(item => {
            return item.y < 0
          })
          if (filterPageY[0]) {
            filterPageY.forEach(page => {
              Dialog.alert({
                title: '提示',
                message: '文档《' + that
                  .currentDocumentObject[key].documentName +
                  '》第' + page.index + '页存在无效位置' +
                  that.keyTypeName + '，请检查拖动一下位置！',
                confirmButtonText: '关闭',
                confirmButtonColor: '#0277FC'
              }).then(() => { });
            })
            canSubmit = false
          }
        }
        console.log('---签名盖章数据---=', theIframeSealData)
        //签名按文档循环提交，盖章按章循环提交
        if (that.certType === '0') {
          if (theIframeSealData && Array.isArray(theIframeSealData
            .pages) && theIframeSealData.pages.length > 0) {
            that.submitData.models.push(theIframeSealData)
          }
        } else {
          if (theIframeSealData && Array.isArray(theIframeSealData
            .pages) && theIframeSealData.pages.length > 0) {
            that.submitData.models = that.submitData.models.concat(
              theIframeSealData.pages);
          }
        }
        canSubmit = true
      } else {
        //that.$Toast('无法获取' + that.keyTypeName + '页面信息！')
        canSubmit = false
      }
      return canSubmit
    },
    //接受处理iframe消息
    handlerMessage() {
      let that = this
      window.addEventListener('message', (event) => {
        this.keyTypeName = this.certType === '0' ? '签名' : '盖章'
        //console.log(event.data.data)
        let postData = event.data.data;
        if (postData && postData.type) {
          switch (postData.type) {
            //签署文件操作提交内容
            case 'sumbit':
              //console.log('submitData-=', that.submitData)
              if (this.checkSignDatas()) {
                Dialog.confirm({
                  title: '提示',
                  message: '请确认文档中所有' + that.keyTypeName + '位置都已拖动' + that
                    .keyTypeName +
                    '图片，点击签署按钮后将完成' + that.keyTypeName + '，不可更改。',
                  confirmButtonText: '确定',
                  confirmButtonColor: '#0277FC'
                })
                  .then(() => {
                    //console.log('提交', that.currentDocumentScrollTop)
                    //that.verifyTokenSumbit()
                    if (process.env.NODE_ENV === 'development') {
                      that.verifyTokenSumbit()
                      //that.testAllPageSeal()
                    } else {
                      that.verifyTokenSumbit()
                    }
                  })
                  .catch(() => { });
              }
              break;
            //显示iframe中的消息
            case 'toast':
              console.log('toast', postData)
              that.$Toast(postData.data)
              break;
            //pdf加载时改弹窗消失
            case 'loaded':
              //console.log('加载消失')
              that.$store.dispatch(that.$LoadShow, false)
              break;
            case 'loading':
              //console.log('加载消失')
              that.$store.dispatch(that.$LoadShow, true)
              break;

          }
        }
      })
    },
    //
    showMessageInfoAlert(message, type, confirmButtonText = '关闭') {
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#0277FC'
      }).then(() => {
        if (type === 0) {
          this.switchSignToView(0)
        }
      });
    },
    //初始化
    init() {
      this.resId = this.$route.query.resId
      this.docId = this.$route.query.docId
      this.corpId = this.$route.query.corpId
      this.staffId = this.$route.query.staffId
      this.certType = this.$route.query.certType
      this.signetType = this.$route.query.signetType
      this.segId = this.$route.query.segId
      this.appCode = this.$route.query.appCode
      this.token = this.$route.query.token
      initIosAuth()
      //this.getAppToken()
      this.setIframeSrc()
      this.handlerMessage()
    },

  },
  mounted() {
    this.init()
  },
  created() {
    window.faceCompareAuthSucced = this.faceCompareAuthSucced
    window.faceCompareAuthFailed = this.faceCompareAuthFailed
  },
  beforeDestroy() {
    //自动回收
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

.sms_pop_parent {
  padding: 0.5rem 0;

  .pop_content {
    padding: 0 1rem;
  }
}
</style>